module.exports = __webpack_public_path__ + "band_1.cff4abf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_1.png
// module id = Lt4X
// module chunks = 0